import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetPlayerDataList from '@/modules/manage-player/api/hooks/useQueryGetPlayerDataList'
import PlayerDataListing from '@/modules/manage-player/components/PlayerData/components/PlayerDataListing'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import { SortOrder } from '@/schema'

type SortOrderOrUndefined = SortOrder | undefined

function PlayerDataListPage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [totalDepositAmountSort, setTotalDepositAmountSort] =
		useState<SortOrderOrUndefined>(SortOrder.desc)
	const [totalWithdrawAmountSort, setTotalWithdrawAmountSort] =
		useState<SortOrderOrUndefined>()
	const [totalProfitSort, setTotalProfitSort] = useState<SortOrderOrUndefined>()
	const [totalWinlossSort, setTotalWinlossSort] =
		useState<SortOrderOrUndefined>()

	const handleSort = (columnId: string, order: SortOrderOrUndefined) => {
		if (columnId === 'totalDepositAmount') {
			setTotalDepositAmountSort(order)
		} else if (columnId === 'totalWithdrawAmount') {
			setTotalWithdrawAmountSort(order)
		} else if (columnId === 'totalProfit') {
			setTotalProfitSort(order)
		} else if (columnId === 'totalWinloss') {
			setTotalWinlossSort(order)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		totalDepositAmountSort,
		totalWithdrawAmountSort,
		totalProfitSort,
		totalWinlossSort,
	}

	const { data, isLoading } = useQueryGetPlayerDataList(payload)

	return (
		<PageContainer>
			<PlayerDataListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
				exportParams={{
					phone: searchQuery || undefined,
					channelName: channelFilter || undefined,
					startDate: dateFilter.startDate || undefined,
					endDate: dateFilter.endDate || undefined,
					totalDepositAmountSort,
					totalWithdrawAmountSort,
					totalProfitSort,
					totalWinlossSort,
				}}
			/>
		</PageContainer>
	)
}

const GuardedPlayerDataListPage = withUserPermission(PlayerDataListPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedPlayerDataListPage
